define('components/can-datepicker',[
	'core/can',
	'moment',
	'datepicker',
	'jquery-inputmask'
], function(can, moment) {

	// Formats
	// http://bootstrap-datepicker.readthedocs.org/en/release/options.html#format
	// http://momentjs.com/docs/#/displaying/

	can.view.attr('can-datepicker', function(el, data) {
		
		var attr = el.getAttribute('can-datepicker');
		
		if (attr !== undefined) {
			new Mask(el, {
				value: data.scope.computeData(attr, {args:[]}).compute
				// value is the only one we really care about, but
				// you could specify other arbitrary options here
				// such as "format: 'MM/DD/YYYY' to be used in your __format methods below"
			});
		}
	});
	
	var Mask = can.Control.extend({
		
		init: function (el, options) {
			
			el.datepicker({
				//forceParse: false,
				format: 'mm/dd/yyyy',
				keyboardNavigation: false,
				autoclose: true,
				orientation: "top left"
			})
			.on('changeDate', can.proxy(function() {
				options.value(this._deformat());
			}, this))
			.on('change', function() {
				if (this.value.trim() === '' && options.value())
					options.value(undefined);
			});
			
			// Date Range -> Start
			var startdate = el.data('startdate');
			if (startdate) {
				el.datepicker('setStartDate', moment.utc(startdate).toDate());
			}
			
			// Date Range -> End
			var enddate = el.data('enddate');
			if (enddate) {
				el.datepicker('setEndDate', moment.utc(enddate).toDate());
			}
			
			el.inputmask({
				mask: '99/99/9999',
				placeholder: '_',
				greedy: true,
				showMaskOnHover: false,
			});
			
			this.set();
		},
		
		// Model -> Input
		_format: function() {
			var value = this.options.value();
			return value ? moment.utc(value).format('MM/DD/YYYY') : undefined;
		},
		
		// Model <- Input
		_deformat: function() {
			// TODO
			var value = this.element.val();
			if (value.match(/^(0?[1-9]|1[012])\/(0?[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/) !== null) {
				// Reason for format after format
				// Deprecation warning: moment construction falls back to js Date. This is discouraged and will be removed in upcoming major release. 
				// Please refer to https://github.com/moment/moment/issues/1407 for more info.
				return moment.utc(value, "MM DD YYYY").format();
			} else {
				return undefined;
			}
		},
		
		// Model change
		'{value} change': 'set',
		
		set: function () {
			var value = this._format();
			if (!this.element.is(":focus"))
				this.element.datepicker('update', value);
		},
		
		destroy: function() {
			this.element.datepicker('remove');
		}
	});
	
});
